import { useRef } from "react";

import { postSwMessage } from "~/features/pwa/messaging.client";
import { useOnLocationChange } from "~/hooks/use-on-location-change";

import { datadogRum } from "@datadog/browser-rum";

/**
 * On every navigation, this hook will send a message to the service worker for synchronization of the React Router manifest.
 */
export const useNavigationSync = (authenticated: boolean) => {
  const isMount = useRef(true);

  useOnLocationChange(() => {
    const mounted = isMount.current;
    isMount.current = false;

    if (!window.__reactRouterManifest) {
      datadogRum.addError("React Router manifest is missing");
      return;
    }

    if ("serviceWorker" in window.navigator && window.navigator.serviceWorker) {
      if (window.navigator.serviceWorker.controller) {
        postSwMessage({
          type: "REMIX_NAVIGATION",
          authenticated,
          isMount: mounted,
          manifest: window.__reactRouterManifest,
        });
      } else {
        async function listener() {
          await window.navigator.serviceWorker.ready;
          if (!window.__reactRouterManifest) {
            datadogRum.addError("React Router manifest is missing");
            return;
          }

          postSwMessage({
            type: "REMIX_NAVIGATION",
            authenticated,
            isMount: mounted,
            manifest: window.__reactRouterManifest,
          });
        }

        window.navigator.serviceWorker.addEventListener(
          "controllerchange",
          listener,
        );
        return () => {
          window.navigator.serviceWorker.removeEventListener(
            "controllerchange",
            listener,
          );
        };
      }
    }
  });
};
